// extracted by mini-css-extract-plugin
module.exports = {"phoneInput":"PhoneInput_phoneInput__z63sy","phoneInputLarge":"PhoneInput_phoneInputLarge__DHy4n","title":"PhoneInput_title__1rNnQ"};